<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="120px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="用户名">
            <el-select v-model="queryForm.user_id" clearable placeholder="请选择用户">
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.nick_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户编号">
              <el-input
              v-model="queryForm.name"
              placeholder="请输入用户编号"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="获取日期">
            <el-date-picker
              v-model="queryForm.dateRange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="用户编号"
          prop="user_name"
        />
        <el-table-column
          align="center"
          label="用户昵称"
          prop="nick_name"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="获取时间"
        >
          <template slot-scope="scope">
            {{ transTime(scope.row.activation_time) }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          align="center"
          prop="refund_time"
          label="芯片地址"
        >
        </el-table-column> -->
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getVisitorList, getVisitorActivityList } from "@/api/radio";
import { transTime } from '@/utils/transTime'

export default {
  data() {
    return {
      transTime,
      businessList: [],
      userList: [],
      queryForm: {
        page: 1,
        pageSize: 10,
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: [], // 时间段
        name:'',
        user_id: '',
        user_num: ''
      }, // 搜索条件表单
      activeNames: "0",
      dialogForm: {}, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
      start: '',
      end: '',
      activity_id: null,
    };
  },
  created() {
    this.getUserList()
    let param = JSON.parse(sessionStorage.getItem("numlist"))
    console.log(222, param)
    this.activity_id = param.id
    this.fetchData()
  },
  mounted() {},

  methods: {
    async getUserList() { 
      let params = {
        userName: '',
        phone: '',
        status: '-1',
        userType: -1,
        page: 1,
        page_size: 10000000000000,
      };
      await getVisitorList(params).then(res => {
        if (res && res.code) {
          this.userList = res.data.data_list
        }
      })
    },
    dateChange(val) {
      if(val){
        const [start, end] = val
        this.start = start + ' 00:00:00'
        this.end = end + ' 23:59:59'
      } else {
        this.start = ''
        this.end = ''
      }
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData()
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      this.queryForm.page = 1;
      this.fetchData()
    },
    async fetchData() {
      let params = {
        start: this.start,
        end: this.end,
        user_id: this.queryForm.user_id,
        name: this.queryForm.name,
        activity_id: this.activity_id,
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      console.log(params);
      await getVisitorActivityList(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    submitForm() {},
  },
};
</script>
<style lang="scss" scoped>
.el-pagination {
  text-align: center;
  margin-top: 10px;
}
</style>